module.exports = __webpack_public_path__ + "img/pt_pc.1f2d6e41.png";